// Where a notification should take the person who taps it. `staff` is true for
// administrators and managers (employees cannot open the manager pages).
export function notificationPath(item, staff) {
    const type = item && item.related_type;
    const id = item && item.related_id;
    switch (type) {
        case 'chat': return id ? `/app/messages?chat=${id}` : '/app/messages';
        case 'private_message': return '/app/messages';
        case 'asset_request': return id ? `/app/requests?id=${id}` : '/app/requests';
        case 'work_order': return staff ? '/app/work-orders' : '/app/my-tasks';
        case 'maintenance_schedule': return staff ? '/app/maintenance' : '/app/my-tasks';
        case 'booking':
        case 'rental_renewal': return staff ? '/app/bookings' : '/app/dashboard';
        case 'report': return '/app/reports';
        case 'inventory_item': return staff ? '/app/inventory' : '/app/my-tasks';
        default: return staff ? '/app/dashboard' : '/app/my-tasks';
    }
}
